import React from "react";

import { Popover, PopoverContent, PopoverTrigger } from "../organisms/popover";

import type { IActionButtonProps } from ".";

import { IconButton } from "@components/molecules/iconButton";
import { Icon } from "@components/atoms/icons";

export const ActionButton = React.memo(function ActionButton(
  props: IActionButtonProps,
) {
  const { children } = props;

  return (
    <Popover placement={"bottom-end"}>
      <PopoverTrigger asChild>
        <IconButton
          label={""}
          icon={<Icon name={"Settings"} />}
          transparent
          noTooltip
        />
      </PopoverTrigger>
      <PopoverContent>{children}</PopoverContent>
    </Popover>
  );
});
